import { EnumHint } from '../entity/enum/enum-hint';

export class GeneralFilterComponent {
    public formFieldAppearance: string;
    public formFieldFloatLabel: string;
    public hintDate: string;
    public hintHour: string;
    public hintNumber: string;
    public hintCalc: string;
    public iconEnableField: string;
    public iconDisableField: string;

    constructor() {
        this.setInitValues();
        this.setHintValues();
    }

    private setInitValues(): void {
        this.formFieldAppearance = 'outline';
        this.formFieldFloatLabel = 'always';
        this.iconEnableField = '';
        this.iconDisableField = 'fa fa-lock iconMenu';
    }

    private setHintValues(): void {
        this.hintNumber = this.getHintMap(EnumHint.Numbers);
        this.hintDate = this.getHintMap(EnumHint.Date);
        this.hintHour = this.getHintMap(EnumHint.Hour);
        this.hintCalc = this.getHintMap(EnumHint.Calc);
    }

    private getHintMap(option?: EnumHint): string {
        const hintMap = new Map<EnumHint, string>();
        hintMap.set(EnumHint.Numbers, 'Somente números são aceitos');
        hintMap.set(EnumHint.Date, 'Formato (dd/mm/yyyy) é aceito');
        hintMap.set(EnumHint.Hour, 'Formato (hh:mm) é aceito');
        hintMap.set(EnumHint.Calc, 'Campo automatico');
        return hintMap.get((option));
    }
}
